/**
 * RTS waterfall bucket definitions.
 *
 * The current tooltip UI renders description-only content, so each waterfall
 * bucket maps to a single user-facing description sourced from product copy.
 */

// label -> { description }
export const RTS_BUCKET_DEFINITIONS = {
    "Inbound": {
        description: "Volume from on road coming back to the station. Not in your station yet."
    },
    "Inbound - RTS": {
        description: "Volume from on road coming back to the station. Not in your station yet."
    },
    "Currently At Station": {
        description: "RTS volume physically in the building."
    },
    "Currently at Station - RTS": {
        description: "RTS volume physically in the building."
    },
    "Pending Reverse Induct": {
        description: "Custody transferred, pending reverse induct. This is the induct backlog."
    },
    "Custody Transfer": {
        description: "The handoff from driver to station. At the building, but not yet scanned by the station."
    },
    "Self-Serve Return": {
        description: "Driver debriefed via the Self Serve flow in Rabbit."
    },
    "Associate Debrief": {
        description: "Not SSR eligible, the driver handed these off and swiped to finish the route."
    },
    "Reverse Inducted — Reattemptable": {
        description: "Reverse Inducted and ready to be reattempted in the next available outbound cycle. Available for same day reattempt."
    },
    "Reverse Inducted — Stowable": {
        description: "Reverse Inducted and ready to be stowed into a reverse container."
    },
    "Delivery Failed": {
        description: "Packages with a failed delivery attempt."
    },
    "Delivery Rejected": {
        description: "Packages rejected by the customer."
    },
    "Manifested": {
        description: "Packages scheduled for a driver to collect. Not picked up yet."
    },
    "In Transit (Seller -> DS)": {
        description: "SWA/MFN en route."
    },
    "In Transit (XPT -> DS)": {
        description: "Reverse volume in transit."
    },
    "In Transit (Customer/Locker -> DS)": {
        description: "P180/Counter return en route."
    },
    "Cancelled Pickups": {
        description: "Doesn't result in RTS volume."
    },
    "Pickup failed": {
        description: "Package doesn't arrive at station for RTS processing."
    },
    "Delivery Cancelled": {
        description: "Packages with cancelled delivery. Counted under Inbound."
    },
    "Received (DS -> FC)": {
        description: "Received for FC return (reverse stowable)."
    },
    "RTS Received (DS -> Customer)": {
        description: "Debriefed reattemptable, pending induct."
    },
    "Marked for Reprocess (DS -> FC)": {
        description: "Pending re-induction."
    },
    "Picked Up": {
        description: "Packages the driver has collected and is bringing back on route."
    },
    "Undeliverable": {
        description: "Stops the driver could not complete, coming back to station for reverse processing."
    },
    "Stowed": {
        description: "Stowed into a reverse container. Ready for Stage and Departure by CPT."
    },
    "Pending Verification (DS -> FC)": {
        description: "Received, awaiting verification."
    }
};

/**
 * Returns the definition for a raw rtsRowMapping label, or null if none is defined
 * (callers should render no tooltip rather than an empty one).
 */
export function getRtsBucketDefinition(label) {
    if (!label) return null;
    return RTS_BUCKET_DEFINITIONS[label] || null;
}

/**
 * Returns the current user-facing tooltip string for a bucket.
 */
export function formatBucketTooltip(label) {
    const def = getRtsBucketDefinition(label);
    return def ? def.description : null;
}



// WEBPACK FOOTER //
// ./src/commons/dataStore/RTSBucketDefinitions.js